<div
  *ngIf="domOpen"
  class="v2-trade-request-detail"
  [class.v2-trade-request-detail--closing]="isClosing"
  [class.v2-trade-request-detail--physical]="!isVirtualCollection"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="partnerName"
  (click.capture)="onOverlayCaptureClick($event)"
>
  <button
    type="button"
    class="v2-trd-floating-back"
    (click)="onClose()"
    [attr.aria-label]="'BACK' | translate"
  >
    <ion-icon name="chevron-back-outline" aria-hidden="true"></ion-icon>
  </button>

  <div
    class="v2-trd-title-pill"
    [class.v2-trd-title-pill--visible]="!isAtTop"
    [attr.aria-hidden]="isAtTop"
  >{{ titlePillLabel }}</div>

  <div
    #bodyScroll
    class="v2-trd-body"
    [class.v2-trd-body--history]="readOnly"
    *ngIf="request"
    (scroll)="onBodyScroll($event)"
  >
    <section class="v2-trd-context">
      <div class="v2-trd-context__identity">
        <div class="v2-trd-avatar-btn">
          <span class="v2-trd-img-wrap v2-trd-img-wrap--avatar">
            <span class="v2-trd-img-skeleton v2-trd-img-skeleton--circle" aria-hidden="true"></span>
            <img
              class="v2-trd-avatar"
              [attr.data-v2-trd-img-key]="avatarImageKey"
              [src]="partnerAvatar"
              alt=""
              loading="lazy"
              decoding="async"
              (load)="revealImage($event)"
              (error)="revealImage($event)"
            />
          </span>
        </div>
        <div class="v2-trd-partner-name-row">
          <p class="v2-trd-partner-name">{{ partnerName }}</p>
          <button
            *ngIf="showLocationsAction"
            type="button"
            class="v2-trd-locations-btn"
            [attr.aria-label]="locationsActionLabel"
            (click)="openTradeLocationsHelp()"
          >
            <ion-icon name="business-outline" aria-hidden="true"></ion-icon>
          </button>
        </div>
        <p class="v2-trd-date">{{ dateLabel }}</p>
        <div class="v2-trd-context__meta">
          <span
            *ngIf="!showWaitingBadge"
            class="v2-trd-status"
            [class.v2-trd-status--cancelled]="isCancelled"
            [class.v2-trd-status--pending]="statusClass === 'pending'"
            [class.v2-trd-status--accepted]="statusClass === 'accepted'"
          >{{ statusKey | translate }}</span>
          <button
            *ngIf="showWaitingBadge"
            type="button"
            class="v2-trd-waiting-badge"
            (click)="openWaitingInfo()"
          >
            {{ 'WATING_FOR_CONFORMATION' | translate }}
          </button>
        </div>
      </div>
    </section>

    <div class="v2-trd-collections" *ngIf="hasOtherCols">
      <span class="v2-trd-collections__label">
        {{ 'COLLECTIONS_INVOLVED' | translate }}
      </span>
      <div class="v2-trd-collections__row">
        <button
          *ngFor="let col of request.OtherCols; trackBy: trackCollectionCol"
          type="button"
          class="v2-trd-col-chip"
          (click)="openOtherColInfo(col)"
        >
          <span class="v2-trd-img-wrap v2-trd-img-wrap--chip">
            <span class="v2-trd-img-skeleton" aria-hidden="true"></span>
            <img
              [attr.data-v2-trd-img-key]="colImageKey(col)"
              [src]="col.collection_icon_path"
              alt=""
              loading="lazy"
              decoding="async"
              (load)="revealImage($event)"
              (error)="revealImage($event)"
            />
          </span>
          <span class="v2-trd-col-chip__label">{{ col.collection_name }}</span>
        </button>
      </div>
    </div>

    <app-v2-accordion
      *ngFor="let section of primarySections; trackBy: trackSection"
      [title]="section.titleKey | translate"
      [count]="section.itemCount"
      [previewStickers]="section.previewStickers"
      [expanded]="isPrimarySectionExpanded(section)"
    >
      <ng-container
        *ngTemplateOutlet="
          stickerItemsTpl;
          context: {
            entries: section.entries,
            emptyKey:
              section.side === 'receive'
                ? 'NO_STICKERS_TO_RECEIVE'
                : 'NO_STICKERS_TO_GIVE'
          }
        "
      ></ng-container>
    </app-v2-accordion>

    <app-v2-accordion
      *ngFor="let otherCol of otherColSections; trackBy: trackOtherCol"
      [title]="otherCol.collectionName"
      [icon]="otherCol.collectionIcon"
      [count]="otherCol.entries.length"
      [previewStickers]="otherCol.previewStickers"
      [expanded]="isOtherColSectionExpanded(otherCol)"
    >
      <ng-container
        *ngTemplateOutlet="
          stickerItemsTpl;
          context: {
            entries: otherCol.entries,
            emptyKey: null
          }
        "
      ></ng-container>
    </app-v2-accordion>

    <ng-template #stickerItemsTpl let-entries="entries" let-emptyKey="emptyKey">
      <div *ngIf="isVirtualCollection" class="v2-trd-sticker-grid">
        <button
          *ngFor="let entry of entries; trackBy: trackEntry"
          type="button"
          class="v2-trd-sticker-card"
          [class.v2-trd-sticker-card--landscape]="entry.landscape"
          (click)="openStickerPreview(entry.item, entry.previewSide)"
        >
          <div
            class="v2-trd-sticker-card__img-wrap"
            [class.v2-trd-sticker-card__img-wrap--landscape]="entry.landscape"
            [class.v2-trd-sticker-card__img-wrap--portrait]="!entry.landscape"
          >
            <span class="v2-trd-img-skeleton" aria-hidden="true"></span>
            <img
              [src]="entry.imgSrc"
              [attr.alt]="entry.item.item_name"
              [attr.data-v2-trd-img-key]="entry.imgKey"
              loading="lazy"
              decoding="async"
              (load)="revealImage($event)"
              (error)="revealImage($event)"
            />
            <span
              *ngIf="entry.qty > 1"
              class="v2-trd-sticker-card__qty"
              aria-hidden="true"
            >×{{ entry.qty }}</span>
          </div>
          <span
            *ngIf="entry.repeated"
            role="button"
            tabindex="0"
            class="v2-trd-sticker-card__repeated"
            (click)="clickRepeatedBadge(entry.item); $event.stopPropagation()"
            (keydown.enter)="clickRepeatedBadge(entry.item); $event.stopPropagation()"
            (keydown.space)="clickRepeatedBadge(entry.item); $event.preventDefault(); $event.stopPropagation()"
          >
            {{ 'REPEATED' | translate }}
          </span>
          <span class="v2-trd-sticker-card__label">#{{ entry.item.item_id }}</span>
        </button>
        <p *ngIf="emptyKey && entries.length === 0" class="v2-trd-empty v2-trd-empty--grid">
          {{ emptyKey | translate }}
        </p>
      </div>

      <div *ngIf="!isVirtualCollection" class="v2-trd-sticker-list">
        <button
          *ngFor="let entry of entries; trackBy: trackEntry"
          type="button"
          class="v2-trd-sticker-row"
          (click)="openStickerPreview(entry.item, entry.previewSide)"
        >
          <span class="v2-trd-sticker-img-wrap">
            <span class="v2-trd-img-skeleton" aria-hidden="true"></span>
            <img
              class="v2-trd-sticker-img v2-trd-sticker-img--compact"
              [attr.data-v2-trd-img-key]="entry.imgKey"
              [src]="entry.imgSrc"
              alt=""
              loading="lazy"
              decoding="async"
              (load)="revealImage($event)"
              (error)="revealImage($event)"
            />
          </span>
          <span
            *ngIf="entry.qty > 1"
            class="v2-trd-qty-badge"
            aria-hidden="true"
          >×{{ entry.qty }}</span>
          <div class="v2-trd-sticker-info">
            <span class="v2-trd-sticker-name">{{ entry.item.item_name }}</span>
            <span class="v2-trd-sticker-id">#{{ entry.item.item_id }}</span>
          </div>
          <button
            *ngIf="entry.repeated"
            type="button"
            class="v2-trd-repeated-badge"
            (click)="clickRepeatedBadge(entry.item); $event.stopPropagation()"
          >
            {{ 'REPEATED' | translate }}
          </button>
        </button>
        <p *ngIf="emptyKey && entries.length === 0" class="v2-trd-empty">
          {{ emptyKey | translate }}
        </p>
      </div>
    </ng-template>
  </div>

  <footer
    *ngIf="showFooter || readOnly"
    class="v2-trd-footer"
    [class.v2-trd-footer--readonly]="readOnly"
    [class.v2-trd-footer--actions]="showFooter"
  >
    <ng-container *ngIf="showFooter">
      <app-btn
        *ngIf="showAcceptBtn"
        icon="checkmark-circle-outline"
        [text]="'ACCEPT_INVITATION_REQUEST' | translate"
        type="primary"
        (clicked)="onAccept()"
      ></app-btn>
      <app-btn
        *ngIf="showCloseBtn"
        icon="checkmark-circle-outline"
        [text]="closeLabelKey | translate"
        type="primary"
        (clicked)="onAccept()"
      ></app-btn>
      <app-btn
        *ngIf="showDeclineBtn"
        icon="close-circle-outline"
        [text]="declineLabelKey | translate"
        type="danger"
        (clicked)="onDecline()"
      ></app-btn>
    </ng-container>
    <p *ngIf="readOnly" class="v2-trd-footer__history-note">
      {{ 'TRADE_REQUESTS_HISTORY_CLOSED' | translate }}
    </p>
  </footer>

  <button
    *ngIf="domOpen && !isAtTop"
    [@trdScrollTopFab]
    type="button"
    class="v2-trd-scrolltop"
    [class.v2-trd-scrolltop--with-footer]="showFooter || readOnly"
    (click)="scrollBodyToTop()"
    [attr.aria-label]="'COL_LIST_SCROLL_TO_TOP' | translate"
  >
    <svg
      class="v2-trd-scrolltop__icon"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
      />
    </svg>
  </button>
</div>
